/**
 * Decides whether a user may open the carrier financials pages (Receivables / Payables).
 *
 * Returns:
 *   'allow'   — render the page
 *   'deny'    — redirect away
 *   'pending' — decision not yet knowable; keep waiting (render nothing)
 *
 * Access mirrors the sidebar Accounting menu: Onward/corporate admins, plus carrier
 * admins (carrier owners and admin/invoicing teammates on an asset-heavy account, as
 * encoded by `isCarrierAdmin` in useClientUser). Account-scoped identities load their
 * `client` record asynchronously, so `isCarrierAdmin` cannot be trusted until it
 * arrives — we wait rather than redirecting mid-load.
 */
export const resolveFinancialsAccess = ({ user, client, isCarrierAdmin }) => {
    if (!user) return 'pending';

    const isAdmin = !!(user.roles?.['ONWARD_ADMIN'] || user.roles?.['ADMIN']);
    if (isAdmin || isCarrierAdmin) return 'allow';

    const accountScoped = !!(
        user.roles?.['CARRIER'] ||
        user.roles?.['CONTRACTOR'] ||
        user.roles?.['SHIPPER'] ||
        user.roles?.['TEAMMATE']
    );
    if (accountScoped && !client) return 'pending';

    return 'deny';
};
